import card1 from './1.jpg';
import card2 from './2.jpg';
import card3 from './3.jpg';
import card4 from './4.jpg';
import card5 from './5.jpg';
import card6 from './6.jpg';
import card7 from './7.jpg';
import card8 from './8.jpg';
import card9 from './9.jpg';
import card10 from './10.jpg';
import card11 from './11.jpg';
import card12 from './12.jpg';
import card13 from './13.jpg';
const cards_data = [
    {
        image:card1,
    },
    {
        image:card2,
        
    },
    {
        image:card3,
        
    },
    {
        image:card4,
        
    },
    {
        image:card5,
        
    },
    {
        image:card6,
        
    },
    {
        image:card7,
       
    },
    {
        image:card8,
       
    },
    {
        image:card9,
        
    },
    {
        image:card10,
        
    },
    {
        image:card11,
        
    },
    {
        image:card12,
        
    },
    {
        image:card13,
        
    },
   
]

export default cards_data;